import { combineReducers } from 'redux';

import claimMethods from 'app/shared/reducers/claimListings/claimMethods';
import modals from 'app/shared/reducers/claimListings/modals';

const rootClaimListingsReducer = combineReducers({
    claimMethods,
    modals,
});

export default rootClaimListingsReducer;
